<template>
    <div class="detection-view">
        <el-row>
            <div style="padding: 20px; display: flex; justify-content: space-between; width: 100%;">
                <div class="block">
                    <span style="color: #333333; line-height: 40px; font-size: 16px;">功能间查询：</span>
                    <el-select v-model="value" clearable placeholder="请选择功能间" style="width: 240px"
                        @change="printSelectedValue">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>

                    <el-button type="primary" icon="el-icon-search" style="margin-left: 20px;"
                        @click="printSelectedDates">搜索</el-button>
                </div>
                <div class="title1">
                    <el-button icon="el-icon-download" type="warning" plain @click="downloadExcel">导出</el-button>
                </div>
            </div>

            <el-col :span="24">
                <div class="grid-content bg-purple">
                    <el-table :data="roomList.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                        style="width: 100%" height="34vh">
                        <el-table-column type="selection" />
                        <el-table-column label="序号" type="index" align="center" width="60">
                        </el-table-column>
                        <el-table-column prop="roomName" label="功能间名称" align="center"></el-table-column>
                        <el-table-column prop="humidity" label="湿度" align="center"></el-table-column>
                        <el-table-column prop="temperature" label="温度" align="center"></el-table-column>
                        <el-table-column prop="ratGuard" label="挡鼠板状态" align="center">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.ratGuard == '1' ? 'success' : 'warning'">
                                    {{ scope.row.ratGuard == '1' ? '开启' : '关闭' }}
                                </el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="gass" label="燃气泄露值" align="center"></el-table-column>
                        <el-table-column prop="gas" label="燃气泄露预警值" align="center"></el-table-column>

                        <el-table-column label="操作" width="200" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="success" plain
                                    @click="goToDeviceManagement1(scope.row.roomName)">查看监控</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>

        <div style="margin-top: 10px; position: fixed; right: 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 30]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <Chart :roomList="roomList" />

        <el-dialog v-model="dialogVisible" fullscreen top="40px" width="70%" draggable>
            <div>
                <video id="video" controls autoplay muted ref="videoRef"></video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Chart from '../components/Chart/Charts.vue'
import { getRoomList } from "@/api/function";
import { Message } from 'element-ui';
export default {
    name: 'DetectionView',
    components: {
        Chart
    },
    data() {
        return {
            value: '',
            options: [
                { value: 'wash', label: '洗消间' },
                { value: 'cook', label: '烹饪间' },
                { value: 'prepare', label: '备餐间' }
            ],
            roomList: [],
            formTime: '',
            formTime1: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            videoRef: null,
            hls: null
        }
    },

    created() {
        this.getRoomList()
    },
    beforeDestroy() {
        this.destroyVideo()
    },
    methods: {
        goToDeviceManagement1(roomName) {
            this.$router.push({
                path: '/monitor',
                query: { roomName }
            });
        },
        getRoomList() {
            getRoomList({ userId: localStorage.getItem('userId') }).then(response => {
                this.roomList = response.data || [];
                this.total = this.roomList.length
            }).catch(error => {
                console.error('获取功能间列表失败:', error);
                Message.error('获取功能间列表失败，请重试');
            });
        },
        printSelectedValue() {
            console.log('选中值:', this.value)
        },

        handleSizeChange(newSize) {
            this.pageSize = newSize
            this.currentPage = 1
        },

        handleCurrentChange(newPage) {
            this.currentPage = newPage
        },

        async printSelectedDates() {
            try {
                const filteredData = this.value
                    ? this.roomList.filter(item => item.roomName.includes(this.options.find(opt => opt.value === this.value)?.label || ''))
                    : [...this.roomList]
                this.roomList = filteredData
                this.total = this.roomList.length
            } catch (error) {
                console.error(error)
            }
        },

        // 修复：导出方法（补上）
        downloadExcel() {
            this.$message.success("导出功能已触发！");
            // 这里后续可以写真实导出逻辑
        },

        edit(row) {
            console.log('编辑功能间数据:', row)
            this.$message.info(`正在编辑【${row.name}】的信息`)
        },

        destroyVideo() {
            if (this.hls) {
                this.hls.destroy()
                this.hls = null
            }
            const video = this.$refs.videoRef
            if (video) {
                video.pause()
                video.src = ''
            }
        }
    }
}
</script>

<style scoped>
.detection-view {
    height: 100%;
    background-color: #fff;
}
</style>